import { render, staticRenderFns } from "./AsignarMembresiaModal.vue?vue&type=template&id=18a10b51&scoped=true"
import script from "./AsignarMembresiaModal.vue?vue&type=script&lang=js"
export * from "./AsignarMembresiaModal.vue?vue&type=script&lang=js"
import style0 from "./AsignarMembresiaModal.vue?vue&type=style&index=0&id=18a10b51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a10b51",
  null
  
)

export default component.exports